import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'gray' | 'black';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    gray: 'bg-gray-50',
    black: 'bg-gray-900 text-white'
  };
  return <section id={id} className={`py-16 md:py-24 ${bgColors[background]} ${className}`} data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">{children}</div>
    </section>;
}